const base = import.meta.env.BASE_URL;

const galleriesList = {
  1: [
    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-1.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-1.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-2.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-2.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-5.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-5.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-14.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-14.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-24.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-24.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-23.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-23.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-20.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-20.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Naowo-Indonezyjska/1x/Indonezyjska-26.jpg`,
      '2x': `${base}gallery-impl/Naowo-Indonezyjska/2x/Indonezyjska-26.jpg`,
    },
  ],
  2: [
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-1.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-1.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-2.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-2.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-3.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-3.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-7.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-7.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-8.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-8.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-9.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-9.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-4.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-4.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-5.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-5.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-6.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-6.jpg`,
    },

    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-10.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-10.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-11.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-11.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-12.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-12.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-13.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-13.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-14.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-14.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-15.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-15.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-16.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-16.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-17.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-17.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-18.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-18.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-19.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-19.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-20.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-20.jpg`,
    },
    {
      '1x': `${base}gallery-impl/silownia-vantage-club_gallery/1x/Vantage-club-21.jpg`,
      '2x': `${base}gallery-impl/silownia-vantage-club_gallery/2x/Vantage-club-21.jpg`,
    },
  ],
  3: [
    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina1.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina1.jpg`,
    },

    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina3.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina3.jpg`,
    },
    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina4.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina4.jpg`,
    },
    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina5.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina5.jpg`,
    },

    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina7.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina7.jpg`,
    },
    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina8.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina8.jpg`,
    },

    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina10.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina10.jpg`,
    },

    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina13.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina13.jpg`,
    },

    {
      '1x': `${base}gallery-impl/IVANISHVILI-Marina strona/1x/IVANISHVILI-Marina16.jpg`,
      '2x': `${base}gallery-impl/IVANISHVILI-Marina strona/2x/IVANISHVILI-Marina16.jpg`,
    },
  ],
  4: [
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania1.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania1.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania2.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania2.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania6.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania6.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania10.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania10.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania11.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania11.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania20.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania20.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania16.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania16.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania17.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania17.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania18.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania18.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania13.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania13.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania22.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania22.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania26.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania26.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania27.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania27.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania32.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania32.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania31.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania31.jpg`,
    },
    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania28.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania28.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania36.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania36.jpg`,
    },

    {
      '1x': `${base}gallery-impl/DM_Mieszkania-strona/1x/DMmieszkania38.jpg`,
      '2x': `${base}gallery-impl/DM_Mieszkania-strona/2x/DMmieszkania38.jpg`,
    },
  ],
  5: [
    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa1.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa1.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa5.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa5.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa6.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa6.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa11.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa11.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa19.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa19.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa22.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa22.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa14.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa14.jpg`,
    },

    {
      '1x': `${base}gallery-impl/Buforowa_89-strona/1x/buforowa18.jpg`,
      '2x': `${base}gallery-impl/Buforowa_89-strona/2x/buforowa18.jpg`,
    },
  ],
   7: [
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka1.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka2.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka3.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka4.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka5.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka6.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka7.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka8.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka9.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka10.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka11.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Strachowicka/1x/Strachowicka12.jpg`,
      '2x': `${base}gallery-impl/Strachowicka/2x/Strachowicka12-2x.jpg`,
    },
  ],
  8: [
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina1.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina2.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina3.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina4.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina5.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina6.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina7.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina8.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina9.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina10.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina11.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina12.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina13.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina14.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina15.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina16.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina17.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Nowa-Lacina/1x/Nowa-Lacina18.jpg`,
      '2x': `${base}gallery-impl/VD-Nowa-Lacina/2x/Nowa-Lacina18-2x.jpg`,
    },
  ],
  9: [
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy1.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy2.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy3.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy4.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy5.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Anny-Jantar/1x/Loka-uslugowy6.jpg`,
      '2x': `${base}gallery-impl/Anny-Jantar/2x/Loka-uslugowy6-2x.jpg`,
    },
  ],
  10: [
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-1.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-2.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-3.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-4.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-5.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-6.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-7.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-8.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-9.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-10.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/VD-Anny Jantar/1x/VD-Anny Jantar-11.jpg`,
      '2x': `${base}gallery-impl/VD-Anny Jantar/2x/VD-Anny Jantar-11-2x.jpg`,
    },
  ],
  11: [
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-1.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-2.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-3.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-4.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-5.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-6.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-7.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-8.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-9.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-10.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-11.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-12.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-13.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-14.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Romuald-Olbrych-Browarna/1x/Browarna-15.jpg`,
      '2x': `${base}gallery-impl/Romuald-Olbrych-Browarna/2x/Browarna-15-2x.jpg`,
    },
  ],
  12: [
    {
      '1x': `${base}gallery-impl/Pulaskiego/1x/Pulaskiego-1.jpg`,
      '2x': `${base}gallery-impl/Pulaskiego/2x/Pulaskiego-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Pulaskiego/1x/Pulaskiego-2.jpg`,
      '2x': `${base}gallery-impl/Pulaskiego/2x/Pulaskiego-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Pulaskiego/1x/Pulaskiego-3.jpg`,
      '2x': `${base}gallery-impl/Pulaskiego/2x/Pulaskiego-3-2x.jpg`,
    },
  ],
  13: [
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-1.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-2.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-3.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-4.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-5.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-6.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-7.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-8.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-9.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-10.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Soltysowicka/1x/Nanowo-Soltysowicka-11.jpg`,
      '2x': `${base}gallery-impl/Soltysowicka/2x/Nanowo-Soltysowicka-11-2x.jpg`,
    },
  ],
  14: [
    {
      '1x': `${base}gallery-impl/Drobnera/1x/Nanowo-Drobnera-1.jpg`,
      '2x': `${base}gallery-impl/Drobnera/2x/Nanowo-Drobnera-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Drobnera/1x/Nanowo-Drobnera-2.jpg`,
      '2x': `${base}gallery-impl/Drobnera/2x/Nanowo-Drobnera-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Drobnera/1x/Nanowo-Drobnera-3.jpg`,
      '2x': `${base}gallery-impl/Drobnera/2x/Nanowo-Drobnera-3-2x.jpg`,
    },
  ],
  15: [
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-1.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-2.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-3.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-4.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-5.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-6.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-7.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-8.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-9.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-10.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-11.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-12.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-13.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-14.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-15.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-16.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-17.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-18.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-18-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-19.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-19-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-20.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-20-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-21.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-21-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-22.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-22-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-23.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-23-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Wichrowa/1x/Wichrowa-24.jpg`,
      '2x': `${base}gallery-impl/Wichrowa/2x/Wichrowa-24-2x.jpg`,
    },
  ],
  16: [
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska1.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska2.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska3.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska4.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska5.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska6.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska7.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska8.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska9.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska10.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska11.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska12.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska13.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska14.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska15.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska16.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska17.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska18.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska18-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska19.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska19-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska20.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska20-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Lubomierska/1x/Lubomierska21.jpg`,
      '2x': `${base}gallery-impl/Lubomierska/2x/Lubomierska21-2x.jpg`,
    },
  ],
  17: [
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny1.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny2.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny3.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny4.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny5.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny6.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny7.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny8.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny9.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny10.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny11.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny12.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny13.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny14.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny15.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny16.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny17.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny18.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny18-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny19.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny19-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny20.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny20-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny21.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny21-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny22.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny22-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny23.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny23-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Awicenny/1x/Awicenny24.jpg`,
      '2x': `${base}gallery-impl/Awicenny/2x/Awicenny24-2x.jpg`,
    },
  ],
  18: [
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-1.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-2.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-3.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-4.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-5.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-6.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-7.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-8.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-9.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-10.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-11.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-12.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-13.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-14.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-15.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-16.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-17.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-18.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-18-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-19.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-19-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-20.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-20-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-21.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-21-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-22.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-22-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-23.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-23-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Kamienna/1x/Nanowo-Kamienna-24.jpg`,
      '2x': `${base}gallery-impl/Kamienna/2x/Nanowo-Kamienna-24-2x.jpg`,
    },
  ],
  19: [
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-1.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-1-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-2.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-2-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-3.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-3-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-4.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-4-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-5.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-5-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-6.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-6-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-7.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-7-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-8.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-8-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-9.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-9-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-10.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-10-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-11.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-11-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-12.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-12-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-13.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-13-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-14.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-14-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-15.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-15-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-16.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-16-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-17.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-17-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-18.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-18-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-19.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-19-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-20.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-20-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-21.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-21-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-22.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-22-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-23.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-23-2x.jpg`,
    },
    {
      '1x': `${base}gallery-impl/Vespucciego/1x/Nanowo-Vespucciego-24.jpg`,
      '2x': `${base}gallery-impl/Vespucciego/2x/Nanowo-Vespucciego-24-2x.jpg`,
    },
  ],
};

export default galleriesList;
